import { Component, OnInit, OnChanges } from '@angular/core';
import { RequestTools } from '@service/request.tools';
import { getInternalPrefUsr } from '@core/_utils/tools.utils';
import { ParamUrlService } from '@service/paramurl.service';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { Tools } from '@service/tools';
import { LayoutService } from '../../layout/service/app.layout.service';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dashbskload',
    templateUrl: 'dashbskload.component.html',
    styleUrls: ['dashbskload.component.scss'],
})
export class DashBskLoadComponent implements OnInit, OnChanges {
    public fr: any;
    public error = false;
    public listColumns: any[];
    public resultDisplay: any;
    public nbRow = 100;
    public isDesktop: boolean = false;
    private internalPrefUsr: any;

    constructor(
        protected _messageService: MessagesService,
        private requestTools: RequestTools,
        private tools: Tools,
        private router: Router,
        private paramUrlService: ParamUrlService,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.isDesktop = this.main.isDesktop();
        this.resultDisplay = new Array();
        this.internalPrefUsr = getInternalPrefUsr();
    }

    public ngOnInit() {
        this.listColumns = this.getlistColumns();
        this.execBskLoad();
    }

    public ngOnChanges() {}

    private async execBskLoad() {        
        let wRes: any = {};
        let wTranfert: any;
        let wMax = '10';
        try {
            wRes = await lastValueFrom(this.requestTools.getBasketListCount('*'));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Err_ListBsk'));
            return;
        }
        wTranfert = this.tools.getBasketTransfert(wRes.getBasketList, wRes.getbskListCount, false, null, null, null);
        this.addBasket(wTranfert.wBasketMailList);
        this.addBasket(wTranfert.wBasketCollectList);
        this.addBasket(wTranfert.wBasketPublishList);
        this.addBasket(wTranfert.wBasketActionList);
        this.addBasket(wTranfert.wBasketInputList);
        this.addBasket(wTranfert.wBasketOutputList);
        this.addBasket(wTranfert.wBasketSystemList);
        this.resultDisplay.sort((a, b) => b.count - a.count);
        wMax = this.internalPrefUsr.bskLoadMax;
        if (wMax !== 'all' && this.resultDisplay.length > Number(wMax)) {
            this.resultDisplay.length = Number(wMax);                                        
        }
        this.resultDisplay = this.resultDisplay.filter((item) => {
            return item.count !== 0;
        })
    }

    private addBasket(aData) {
        aData.forEach((item) => {
            if (item.Information.docCount !== '0') {
                this.resultDisplay.push({
                    name: item.Information.Name,
                    label:item.Information.Label,
                    count: parseInt(item.Information.docCount),
                    basketType: item.Information.basketType,
                    url: item.Information.url,
                    defUrl: item.Information.defUrl,
                    description: item.Information.Description,
                    color: item.Information.color
                })
            }
        });
    }

    public updateUrl(aData) {
        aData.url = aData.defUrl;
    }

    public onRowSelect(event) {
        this.paramUrlService.basketName = event.data.name;
        this.router.navigate(['/page-basket-list']);
    }

    private getlistColumns() {
        let wItem: any;
        let wColList = new Array();
        wItem = { header: '', field: 'url', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Col_Inti_1') , field: 'label', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Doc_Tot'), field: 'count', type: 'Double' };
        wColList.push(wItem);        
        return wColList;
    }
}
